module.exports = __webpack_public_path__ + "static/media/bordado_icon.d4bf1710.svg";